import { newApiFetchV2 } from "./utils";

export const getMarketingChannelsData = () => newApiFetchV2("/_the_marketing_channels", {});
